const en={
    login:{
        title:'Data Submission System',
        email:'Email',
        password:'Password',
        forgotPassword:"Forgot Password",
        logout:"Log out",
        inEmail:'Incorrect email format',
        loginfailed:'Login failed, email or password incorrect',
        enterEmail:'Please enter your email',
        enterPassword:'Please enter your password',
        enterCode:'Please enter the verification code',
        passwordNotMatch:'Passwords do not match',
    },
    forgot:{
        forgotPassword:"Forgot Password",
        tip:"We'll send a code to your email address",
        email:'Email',
        code:"Verification Code",
        password:'Password',
        confirmPassword:"Confirm Password",
        send:"Send",
        submit:"Submit",
        login:"Sign in"
    },
    menu:{
        mange:"Form Management",
        mangeTip:"数据提报表单的创建、数据查看",

        submission:"Form Submission",
        account:"Account Management",
        uwell:"Uwell Account",
        external:"External account"
    },
    editList:{
        fill:"Fill out",
        record:"Record",
        createdTime:"Created time",
        formTitle:"Form title",
        titleTip:"Please enter form title",
        showInput:"Show you the forms to be filled out and the filling records"
    },
    editFill:{
        save:"Save",
        nosave:`Don't save`,
        backSaveTip:'Do you want to save the entered content?',
        submitted:'Submitted',
        notsubmitted:'Not Submitted',
        submit:"Submit",
        submitSuccess:"Submitted successfully",
        fillAgain:"Fill out again",

        invalid:"Invalid parameters",
        noTime:"The form is no longer valid and cannot be filled out.",
        failedStop:"Submission failed. The form collection has stopped.",
        failedNot:"Submission failed. The form does not exist.",
        failedPassed:"Submission failed. The form can only be filled out once.",
        failedOnce:"Submission failed, The form can only be filled out once per day.",
        noempty:"Required fields cannot be empty."
    },
    editInfo:{
        SubmitTime:"Submission time",
        submitter:'Submitter',
        search:"Search",
        clear:"Clear",
        filter:"Filter",
        fieldSetting:"Field Settings",
        export:"Export",
        createBy:"Create By",
        updateTime:"Update time",
        status:'Status',
        action:"Action",
        detail:"Detail",
        edit:"Edit",
        more:"More",
        copy:"Copy",
        startDate:"Start Date",
        endDate:"End Date",
        selectAll:"Select All",
        confirm:"Confirm",
        cancel:"Cancel",
        addFilter:"Add Filter",
        pleaseSelect:"Please Select",
        pleaseFillIn:"Please Fill In",
        delete:"Delete",
        filterIncom:`The filter conditions in row {num} are incomplete, please confirm.`,
        noData:"No Data Available",
        uploadfailed:'Upload failed',
        total:`Total {num}`,

        deleteTip: 'This operation will delete the data. Do you want to continue?',
        deleteSuccess: 'Deletion successful'
    },
    fillIn:{
        equal:'Equal to',
        noequal:'Not equal to',
        contains:'Contains',
        notcontains:'Does not contain',
        empty:'Empty',
        notempty:'Not empty',
        before:'Before',
        after:'After',
        greaterequal:'Greater than or equal to',
        lessequal:'Less than or equal to',
        greaterthan:'Greater than',
        lessthan:'Less than',

    },
    editEye:{
        detail:"Form Detail"
    },
    editUpdate:{
        editForm:"Edit form",
        returnList:"Return to list"
    }
}

export default en;